module.exports = __webpack_public_path__ + "img/twitter.46261a76.svg";